
import axios from "axios";
import config from "../config";
import { getToken, setToken, removeToken } from "../utils/token";

const api = axios.create({
  baseURL: config.API_URL,
  withCredentials: true, // ✅ required for sending cookies (refresh token
});


// ✅ REQUEST INTERCEPTOR → attach access token
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ✅ /** Error handling interceptor if token is expired or invalid user will be logged out */
/** code before implementation of refresh token
api.interceptors.response.use( 
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      removeToken();
      window.location.href = "/login"; // redirect
    }
    return Promise.reject(error);
  }
);
*/


// RESPONSE INTERCEPTOR → handle token expiry
api.interceptors.response.use(
  (response) => response,

  async (error) => {
    if (axios.isCancel(error) || error.code === "ERR_CANCELED") {
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    // ✅ If token expired (403) and not retried yet
    if (
      error.response &&
      error.response.status === 403 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        // Call refresh API (cookie will be sent automatically)
        const res = await axios.post(
          `${config.API_URL}/refresh`,
          {},
          {
            withCredentials: true, //  send refresh token cookie
          }
        );

        const newAccessToken = res.data.accessToken;

        // Save new token
        setToken(newAccessToken);

        // Update header and retry original request
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        return api(originalRequest);

      } catch (refreshError) {
        // ❌ Refresh failed → logout user
        removeToken();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    // ✅ Handle unauthorized (401)
    if (error.response && error.response.status === 401) {
      removeToken();
      window.location.href = "/login";
    }

    // ✅ Handle service unavailable (503)
    if (error.response && error.response.status === 503) {
      // You can show a global toast, modal, or redirect
      console.error("Service unavailable:", error);
      alert("Service temporarily unavailable. Please try again later.");
    }

    // ✅ Handle network errors (no response)
    if (!error.response) {
      console.error("Network error:", error);
      alert("Network error. Please check your connection.");
    }

    return Promise.reject(error);
  }
);

export default api;